<template>
  <section class="section section-gallery bg-light2">
    <div class="container container-small">
      <header>
        <TextSection
          :header="header"
          :description="description"
          :underline="true"
          :uppercase="false"
          :cutLength="570"
          :cutLengthTextBig ="200"
        />
      </header>
      <div class="slider" :class="{'slider-mode': this.items.length > 3}">
        <SliderControllers class="controllers" @showPrev="showPrev" @showNext="showNext" :displayPrev="true" :displayNext="true" :small="true"
        :class="{
          'controllers-full': activeFullItem !== null
        }"/>
        <div class="images slide-wrapper">
          <figure
            class="slide"
            v-for="(item, index) in items"
            :key="index"
            :class="{
              full: activeFullItem === index,
              prev: index == (activeItem - 1 + items.length) % items.length,
              active: index == activeItem,
              next: index == (activeItem + 1) % items.length
            }"
          >
            <img :src="item" :alt="museumData.title">
            <button class="button-maximize" @click="toggleActive(index)">
              <div class="button-icon">
                <svg class="top">
                  <use xlink:href="#arrowRight2DarkSvg"></use>
                  <use class="use-contrast" xlink:href="#arrowRight2ContrastSvg"></use>
                </svg>
                <svg class="down">
                  <use xlink:href="#arrowRight2DarkSvg"></use>
                  <use class="use-contrast" xlink:href="#arrowRight2ContrastSvg"></use>
                </svg>
              </div>
            </button>
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'
import SliderControllers from '@/components/SliderControllers.vue'

export default {
  name: 'gallerySection',
  components: {
    TextSection,
    SliderControllers
  },
  props: ['items', 'description', 'header'],
  data: function () {
    return {
      activeFullItem: null,
      activeItem: 1
    }
  },
  computed: {
    ...mapGetters([
      'museumData'
    ])
  },
  methods: {
    toggleActive (index) {
      this.activeFullItem = this.activeFullItem === index
        ? null
        : index
      this.activeItem = index
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.activeFullItem = this.activeFullItem !== null ? this.activeItem : null
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.activeFullItem = this.activeFullItem !== null ? this.activeItem : null
    },
    handleKeyup (event) {
      if (event.code === 'Escape') {
        this.activeFullItem = null
      }
      if (event.code === 'ArrowRight') {
        this.showNext()
      }
      if (event.code === 'ArrowLeft') {
        this.showPrev()
      }
    }
  },
  created: function () {
    window.addEventListener('keyup', this.handleKeyup)
  },
  destroyed: function () {
    window.removeEventListener('keyup', this.handleKeyup)
  }
}
</script>

<style scoped lang="scss">
  .slider {
    position: relative;
    .slider-mode {
      padding-top: 50px;
      .controllers {
        display: block;
      }
    }
  }
  .controllers {
    position: absolute;
    display: none;
    z-index: 3;
    top: 0;
    left: 0;
    width: 86px;
    &.controllers-full {
      display: block;
      position: fixed;
      z-index: 99999999;
      width: 90%;
      max-width: 1400px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 50%;

      /deep/ button {
        width: 50%;
        height: 50vh;
        display: block;
        cursor: pointer;
        &.prev {
          text-align: left;
        }
        &.next {
          text-align: right;
        }
      }
    }
  }
  .section {
    .container {
      padding: 45px 0;
    }
  }
  .images {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @include mobile {
      flex-direction: column;
    }
  }
  .slide {
    display: none;
    &.active,
    &.prev,
    &.next {
      display: block;
    }
  }
  .button-maximize {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: none;
    background-color: transparent;
    border: none;
    z-index: 1;
    cursor: nesw-resize;
    .button-icon {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 40px;
      height: 40px;
    }
    @include mobile {
      display: none;
    }
    &:focus {
      outline: none;
    }
    svg {
      width: 12px;
      height: 12px;
      position: absolute;
      top: 50%;
      left: 50%;
      &.top {
       transform: translate(0, -100%) rotate(-45deg);
      }
      &.down {
       transform: translate(-100%, 0) rotate(135deg);
      }
    }
    &:hover {
      svg.top {
        animation-name: arrowtopmove;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        animation-duration: 2s;
      }
      svg.down {
        animation-name: arrowdownmove;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        animation-duration: 2s;
      }
    }
  }
  figure {
    position: relative;
    margin: 10px 0 20px;
    // cursor: pointer;
    height: 310px;
    width: 310px;
    overflow: hidden;
    @include mobile {
      cursor: auto;
    }
    img {
      //max-width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 150%;
      max-height: 130%;
      width: 1200px;
      height: auto;
      min-width: 100%;
      min-height: 100%;
    }
    &.full {
      @include biger-then-mobile {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: $bg-light;
        z-index: 9999999;
        margin: 0;
        padding: 0;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 80vw;
          max-height: 80vh;
          width: 1200px;
          height: auto;
          min-width: 50vw;
          min-height: 30vh;
        }
        svg {
          &.top {
            transform: translate(0, -100%) rotate(135deg);
            animation-name: activearrowtopmove !important;
          }
          &.down {
            transform: translate(-100%, 0) rotate(-45deg);
            animation-name: activearrowdownmove !important;
          }
        }
      }
    }
    @include desktop-small {
      max-width: 28vw;
      &.active {
        max-width: 100%;
      }
      img {
        max-width: 100%;
      }
    }
    @include mobile {
      max-width: 100%;
      text-align: center;
    }
  }
  @keyframes arrowtopmove
  {
    0%
    {
      transform: translate(0, -100%) rotate(-45deg);
    }
    50%
    {
      transform: translate(-10%, -90%) rotate(-45deg);
    }
    100%
    {
      transform: translate(0, -100%) rotate(-45deg);
    }
  }
  @keyframes arrowdownmove
  {
    0%
    {
      transform: translate(-100%, 0) rotate(135deg);
    }
    50%
    {
      transform: translate(-90%, -10%) rotate(135deg);
    }
    100%
    {
      transform: translate(-100%, 0) rotate(135deg);
    }
  }
  @keyframes activearrowtopmove
  {
    0%
    {
      transform: translate(0, -100%) rotate(135deg);
    }
    50%
    {
      transform: translate(-10%, -90%) rotate(135deg);
    }
    100%
    {
      transform: translate(0, -100%) rotate(135deg);
    }
  }
  @keyframes activearrowdownmove
  {
    0%
    {
      transform: translate(-100%, 0) rotate(-45deg);
    }
    50%
    {
      transform: translate(-90%, -10%) rotate(-45deg);
    }
    100%
    {
      transform: translate(-100%, 0) rotate(-45deg);
    }
  }
</style>
